import React from 'react';
import { Link } from 'react-router-dom';
import Logo from 'volto-gforce/components/Logo';
import SocialIcons from 'volto-gforce/components/SocialIcons';
import { NAV, QUOTE_CTA, CONTACT } from 'volto-gforce/components/nav';

const Footer = () => (
  <footer className="gf-footer" role="contentinfo">
    <div className="gf-wrap">
      <div className="gf-fgrid">
        <div className="gf-fbrand">
          <Link to="/" className="gf-logo-link" aria-label="GForce Promotions home"><Logo variant="white" /></Link>
          <SocialIcons className="gf-social gf-social-footer" />
        </div>
        <ul aria-label="Site">
          {NAV.map((i) => <li key={i.href}><Link to={i.href}>{i.title}</Link></li>)}
          <li><Link to={QUOTE_CTA.href}>{QUOTE_CTA.title}</Link></li>
        </ul>
        <ul aria-label="Contact">
          <li>{CONTACT.name}</li>
          <li><a href={`tel:${CONTACT.tel}`}>{CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
          <li>{CONTACT.town}</li>
        </ul>
      </div>
      <div className="gf-base">
        <span>© 2026 GForce Promotions</span>
        <span className="gf-legal"><Link to="/privacy-policy">Privacy Policy</Link><Link to="/terms">Terms &amp; Conditions</Link></span>
      </div>
    </div>
  </footer>
);
export default Footer;
